// extracted by mini-css-extract-plugin
module.exports = {"heading":"resource-block_heading__27Z-D","subheading":"resource-block_subheading__3CI_f","element":"resource-block_element__WDr8e"};